import { Box, Typography } from "@material-ui/core"
import { useEffect, useState } from "react"
import styled from "styled-components"

const StyledBox = styled(Box)`
  margin-top: 40px;
`

const StyledText = styled(Typography).attrs({ variant: "h4" })<{
  $color: string
}>`
  color: ${(p) => p.$color};
  font-size: 40px;
`

type TimerProps = {
  mins: number
  secs: number
  setTime: React.Dispatch<React.SetStateAction<[number, number]>>
}

const Timer = ({ mins, secs, setTime }: TimerProps) => {
  const [timeLeft, setTimeLeft] = useState(null)
  const calculateTime = () => {
    if (secs === 0 || secs % 5 === 0) {
      setTimeLeft(`נשאר ${mins} דקות ו ${secs} שניות`)
    }

    if (mins === 0 && secs === 0) {
      setTime([0, 0])
    } else if (secs === 0) {
      setTime([mins - 1, 59])
    } else {
      setTime([mins, secs - 1])
    }
  }

  useEffect(() => {
    const timer = setInterval(() => calculateTime(), 1000)

    return () => {
      clearInterval(timer)
    }
  })

  return (
    <StyledBox role="timer">
      <Typography role="alert" variant="srOnly">
        {timeLeft}
      </Typography>
      <StyledText $color={mins === 0 && secs === 0 ? "#757575" : "#000000"}>
        {`${mins.toString().padStart(2, "0")}:${secs
          .toString()
          .padStart(2, "0")}`}
      </StyledText>
    </StyledBox>
  )
}

export default Timer
